import { Box, Skeleton, styled } from "@mui/material"
import { colors } from "../../theme/colors"

export const ContentContainer = styled(Box)({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  width: "100%",
  borderRadius: 26,
  backgroundColor: colors.yellow,
  padding: "10px 18px",
  boxSizing: "border-box",
})

export const SkeletonLoader = styled(Skeleton)({
  borderRadius: "50px",
})
